var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('Table',{attrs:{"border":"","columns":_vm.columns12,"data":_vm.data6,"loading":_vm.loading},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return undefined}}])}),_vm._v(" "),_c('div',{staticClass:"my-page"},[_c('page',{attrs:{"total":_vm.total},on:{"updatePage":_vm.updatePage,"updateSize":_vm.updateSize}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"query"},[_c('div',{staticClass:"checkbox"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8a06e1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm/admin/uuid/list.vue
// module id = null
// module chunks = 